import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const registrationTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-registration-type/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const registrationTypeParentList = (params) => {
  return _baseClient.get('/unit-registration-type/parent-list', params);
};

export const registrationTypeAdd = (params) => {
  return _baseClient.post('/unit-registration-type/save', { body: params }).then((response) => {
    return response;
  });
};

export const registrationTypeDelete = (params) => {
  return _baseClient.get('/unit-registration-type/delete', params);
};

export const registrationTypeDetail = (params) => {
  return _baseClient.get('/unit-registration-type/get', params);
};

export const registrationTypeUpdateStatus = (params) => {
  return _baseClient.get('/unit-registration-type/update-status', params);
};
